module.exports = __webpack_public_path__ + "static/media/Marsha Haverty.de8e5784.png";